// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "clup-8028c.firebaseapp.com",
  "projectId": "clup-8028c",
  "storageBucket": "clup-8028c.appspot.com",
  "messagingSenderId": "915498835901",
  "appId": "1:915498835901:web:23f39de83da305b8cd7cd4",
  "measurementId": "G-6J5W5QW6J2",
  "apiKey": "AIzaSyA7fUyG6VFzOcgCj_mi5TrB2VJGqX0VMz4"
};
